import { OperationTypeEnum, SubPlantCodesEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";

export class StockTransferDto {
    @ApiProperty()
    @IsNotEmpty({message:"Lot Number should not be empty"})
    lotNo: string;
    @ApiProperty()
    @IsNotEmpty({message:"Sub Lot Number should not be empty"})
    subLotNo: string;    
    @ApiProperty()
    @IsNotEmpty({message:"Plant should not be empty"})
    plantId: number;
    @ApiProperty()
    @IsNotEmpty({message:"Plant should not be empty"})
    plantName: string;  
    @ApiProperty()
    @IsNotEmpty({message:"Sub plant should not be empty"})
    subPlantId: number;
    @ApiProperty()
    @IsNotEmpty({message:"Sub Plant should not be empty"})
    subPlantName: string;
    @ApiProperty()
    @IsNotEmpty({message:"Quantity should not be empty"})
    quantity: number;
    @ApiProperty()
    @IsNotEmpty({message:"No of boxes should not be empty"})
    noOfBoxes: number;
    @ApiProperty()
    estimatedDate:Date;
    @ApiProperty()
    @IsNotEmpty({message:"Count should not be empty"})
    count: number;
    @ApiProperty()
    @IsNotEmpty({message:"Production inventory id should not be empty"})
    prodInvId: number;
    @ApiProperty({
        enum:OperationTypeEnum,
        default: OperationTypeEnum.GRN
    })
    @IsNotEmpty({message:"Operation should not be empty"})
    operation: OperationTypeEnum;
    @ApiProperty({
        enum:OperationTypeEnum,
        default: OperationTypeEnum.GRN
    })
    @IsNotEmpty({message:"Operation should not be empty"})
    nextOperation: OperationTypeEnum;
    @ApiProperty()
    @IsNotEmpty({message:"Created user should not be empty"})
    createdUser: string;
    @ApiProperty()
    inventoryplantId:number;
    @ApiProperty()
    previousOperation?:OperationTypeEnum;
}